/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module VsSecurityDashboardPageModule
 */

import { Pipe, PipeTransform } from '@angular/core';

/**
 * @description Given a boolean, returns the associated Clarity status.
 * @author alextsg
 */
@Pipe({
    name: 'booleanToClarityStatus',
})
export class BooleanToClarityStatusPipe implements PipeTransform {
    // eslint-disable-next-line class-methods-use-this
    public transform(enabled = false): 'success' | '' {
        return enabled && 'success' || '';
    }
}
